import React from "react";
import { CalciteButton } from "@esri/calcite-components-react";

type LocType = "Center" | "Home" | "School";

export type CostType = "Free" | "Free or a small fee" | "Cost varies, contact provider";

const settingStyles: Record<LocType, { bg: string; text: string }> = {
  School: { bg: "#BBB2E7", text: "#262525" },
  Home: { bg: "#71C4A2", text: "#262525" },
  Center: { bg: "#FFBE67", text: "#262525" },
};

const costStyles: Record<CostType, { bg: string; text: string; label: string }> = {
  Free: { bg: "#7FBFFE", text: "#262525", label: "Free" },
  "Free or a small fee": { bg: "#D6E6F5", text: "#262525", label: "Free or a small fee" },
  "Cost varies, contact provider": { bg: "#D9D9D9", text: "#262525", label: "Cost varies, contact provider" },
};

export default function LocationBadges({
  locType,
  costType,
}: {
  locType?: LocType;
  costType?: CostType;
}) {
  const setting = locType ? settingStyles[locType] : undefined;
  const cost = costType ? costStyles[costType] : undefined;

  return (
    <>
      {/* COST badge first */}
      {cost && (
        <CalciteButton
          class="lib-secondary-button cost-btn"
          appearance="solid"
          scale="s"
          style={{
            "--calcite-button-background-color": cost.bg,
            "--calcite-button-text-color": cost.text,
            "--calcite-button-corner-radius": "4px",
            padding: "8px 4px 8px 0px",
            pointerEvents: "none",
            cursor: "not-allowed",
          }}
        >
          {cost.label}
        </CalciteButton>
      )}

      {/* Setting badge */}
      {locType && setting && (
        <CalciteButton
          class="lib-secondary-button setting-btn"
          appearance="solid"
          scale="s"
          style={{
            "--calcite-button-background-color": setting.bg,
            "--calcite-button-text-color": setting.text,
            "--calcite-button-corner-radius": "4px",
            padding: "8px 4px 8px 0px",
            pointerEvents: "none",
            cursor: "not-allowed",
          }}
        >
          {locType}-based care
        </CalciteButton>
      )}
    </>
  );
}